import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  ossFiles: { data: [], loading: false },
  publishedFiles: { data: [], loading: false },
  confirm: { name: '', data: '', title: '', content: '', visible: false, loading: false },
  reload: { needReload: false, uploadPath: '' },
  uploadPolicy: { data: null, loading: false },
  breadcrumbs: [],
  fileTree: [],
  loading: false,
  tab: 0,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
